import {
  InitClient,
  GetByParas,
  Post,
  PostWithParas,
  PostNoParas,
} from "../ZeusAPIClient.js";
import { apiConfig } from "../../config.js";
import { PagingBody } from "../Model/PagingBody";
import { Predicate } from "../Model/Predicate";

InitClient(apiConfig.clientId, apiConfig.clientSecret, apiConfig.host);
//获取KPI设置列表
async function GetKPISettingList(
  usercode,
  roleKey,
  frameId,
  period,
  pageIndex,
  pageSize,
  searchText
) {
  var paras = {
    userCode: usercode,//工号
    roleKey: roleKey,//当前角色
    frameId: frameId,//部门id
    p: pageIndex,//页码
    pageSize: pageSize,//页大小
    period:period,//类型 0月度 1季度
  };
  return await PostWithParas("4ca83db1-1f2a-4b73-8696-b9a55d178cdf", paras,searchText);
}
//获取KPI详情
async function ViewKPIDetail(id) {
  var paras = {
    id: id,
  };
  return await GetByParas("6f96fa9d-3276-471a-afdf-01dd278aaac8", paras);
}
//根据KPI类别获取KPI名称预设项
async function GetKPINameOptions(parentId) {
  var paras = {
    parentId: parentId,
  };
  return await GetByParas("c41720ad-6b7e-4ff3-9ab0-9fd6a34a255f", paras);
}

//根据parentid获取包括当前部门及当前部门下所有部门
async function GetFrameListByPid(parentId){
  var paras = {
    parentid: parentId,
  };
  return await GetByParas("e0e743e4-ce52-400a-b862-474391774e8c", paras);
}
// 获取当前部门下人员
async function GetUsers(mainid,userCode,IsUser){

  var paras = {
    mainid: mainid,
    userCode:userCode,
    IsUser:IsUser
  };
  if(mainid=='undefined'||mainid==''||mainid==null||userCode=='undefined'||userCode==''||userCode==null){
    return false;
  }else{
    return await GetByParas("72b3e67c-a531-464d-884f-547652585e9a", paras);
  }
}
//获取当前操作部门
async function GetChargeDeptsByUserCode(userCode) {
  var paras = {
    userCode: userCode,
  };
  return await GetByParas("0cbe55b2-6993-4deb-8c5d-b6927df479b0", paras);
}
//根据KPI类型,KPI姓名,周期获取KPI模板
async function GetTempateByKPITypeAndKPIName(type, name, periodType) {
  var paras = {
    KPIType: type,
    KPI: name,
    PeriodType: periodType,
  };
  return await GetByParas("c5e672d1-580a-4e5f-85f8-fbfab91e9393", paras);
}
//编辑时删除KPI项目
async function DeleteKPIItem(userCode, ids) {
  var paras = {
    userCode: userCode,
  };
  //ids: ids, KPI ids
  return await PostWithParas("955ba1c8-b6be-4b18-8452-393bdb757494", paras,ids);
}
//保存
async function SaveKPIItems(paras, kpiItems) {
  if (kpiItems.length > 0) {
    return await PostWithParas("d1d64698-1bdb-4edf-9846-2edfd7204c1c", paras,kpiItems);
  }
}
//获取我的KPI
async function GetMyKPI(userCode,periodType,period,years){
  var paras={
    userCode:userCode,//工号
    periodType:periodType,//周期类型 0月度 1季度
    period:period,//周期 月度为1-12，季度为Q1-Q4
    years:years//当前年
  };
  return await GetByParas('b33ade56-f69c-4798-a04e-aed6cce5abc6',paras);
}

//获取我的kpi评分信息
async function GetMyKPIScore(id){
  var paras={
    id:id
  };
  return await GetByParas('b40b479f-e5d3-4b72-831c-c9a0a2b1fa55',paras);
}

//自评kpi 7e6c5bde-d586-41bc-8e8f-7372d42abc58
async function UpdateSelfScore(userCode,Id,SelfScore,Execution){
  var data={
    userCode:userCode,//工号
    Id:Id,//当前KPI评分id
    Score:SelfScore,//自评分数
    Execution:Execution//完成情况
  };
  return await PostWithParas('7e6c5bde-d586-41bc-8e8f-7372d42abc58',{},data);
}

//领导评分kpi 7e6c5bde-d586-41bc-8e8f-7372d42abc58
async function UpdateLeadScore(userCode,Id,LeadScore,Execution){
  var data={
    userCode:userCode,//工号
    Id:Id,//当前KPI评分id
    Score:LeadScore,//自评分数
    Execution:Execution//完成情况
  };
  return await PostWithParas('38ed4dc7-45df-42bc-ad52-a577256ef53b',{},data);
}

//获取需我评分列表
async function GetNeedMyScoreKPI(userCode,periodType,period,years,p,pageSize,title){
  var paras={
    userCode:userCode,//工号
    periodType:periodType,//周期类型 0月度 1季度
    period:period,//周期 月度为1-12，季度为Q1-Q4
    years:years,//当前年
    p:p,//页码
    pageSize:pageSize,//页大小
  };
  return await PostWithParas('0daca78d-c836-4fa4-a94f-8dd61f0c9de2',paras,title);
}

//获取审核KPI列表
async function AuditkpiList(roleKey,KPIType,periodMonth,periodJ,TrueName,statusJ,resultStatus,p,pageSiZe){
  var data={
    roleKey:roleKey,//当前角色
    KPIType:KPIType,//类型 0月度 1季度
    PeriodMonth:periodMonth,//月度周期
    PeriodJ:periodJ,//季度周期
    TrueName:TrueName,//创建人姓名
    StatusJ:statusJ,//计划审核状态
    ResultStatus:resultStatus,//结果审核状态
    p:p,//页码
    pageSiZe:pageSiZe//页大小
  };
  return await PostWithParas('d78ee65c-99d6-481b-bd5a-dcdb15473ecc',{},data);
}

//获取KPI部门树形图
async function GetTreeDeptsData(frameid,roleKey){
  var paras={
    frameid:frameid,//部门id
    roleKey:roleKey,//当前角色名
  };
  return await PostWithParas('a653df54-1da0-4fd9-96b2-088637102178',paras,{});
}

//根据部门获取其下的员工和当月考核信息
async function GetPageUserKPIByDeptId(thisperiod,frameid,years,kpitype,title,p,pageSize){
  var paras={
    thisperiod:thisperiod,//周期 
    frameid:frameid,//部门id
    p:p,//页码
    pageSize:pageSize,//页大小
    years:years,//年份
    kpitype:kpitype,//类型
    periods:1,//周期
  };

  return await PostWithParas('f629f96c-ce1a-4f92-9020-67cfa70288bd',paras,title);
}

//pc版根据InfoId获取部门下该周期内设置
async function GetItemListByInfoPC(roleKey,UserName,DutyId,MainId,KPIType,InfoId,p,pageSize){
  var data={
    roleKey:roleKey,//周期
    UserName:UserName,//部门id
    DutyId:DutyId,//岗位id
    MainId:MainId,//部门id
    KPIType:KPIType,//KPI类型
    InfoId:InfoId,//信息id
    p:p,//页码
    pageSize:pageSize,//页大小
  };

  return await PostWithParas('c0ccd650-a19c-4eb0-8b7d-87dfcc3cbd63',{},data);
}

//CEO驳回
async function UpdateStatus(KpiinfoId,UserId,UserCode,becauseOf){
  var paras={
    KpiinfoId:KpiinfoId,//KPIId
    UserId:UserId,//用户id
    UserCode:UserCode,//用户工号
  };

  return await PostWithParas('13797acf-b00f-4d25-91af-d819f9daafcf',paras,becauseOf);
}

//HR和IDC角色驳回
async function UpdateKPIStatus(Id,userCode,resultType,isResult,becauseOf){
  var paras={
    Id:Id,//KPIId
    userCode:userCode,//用户工号
    resultType:resultType,//操作类型 0驳回 1完成
    isResult:isResult,//是否为结果审核 0否为计划审核 1是为结果审核
  };
  console.log('paras',paras);
  return await PostWithParas('dd864ef5-8c38-421e-984c-42acf193abaa',paras,becauseOf);
}

//当前登录人是否已经提交
async function MyUserKpi(period,years,frameid,kpitype,roleKey,userCode){
  var paras={
    period:period,//周期
    years:years,//当前年份
    frameid:frameid,//部门id
    kpitype:kpitype,//类型 0月度 1季度
    roleKey:roleKey,//当前角色
    userCode:userCode,//当前登录人工号
  };

  return await PostWithParas('82c95fb1-704f-458e-b5ec-616d929c8887',paras,{});
}

//发送KPI审核
async function SendFrameResult(frameid,kpitype,period,years,userCode,userId,isResult){
  var paras={
    frameid:frameid,//部门id
    kpitype:kpitype,//类型 0月度 1季度
    period:period,//周期
    years:years,//年
    userCode:userCode,//工号
    userId:userId,//用户id
    isResult:isResult,//是否为结果审核 0否为计划审核 1是结果审核
  };
  return await PostWithParas('dad619b3-e9ba-46c2-bd14-409738ad2063',paras,{});
}

//获取KPI评分
async function GetKPIScore(p,pageSize,period,frameid,kpitype,years,title){
  var paras={
    p:p,//页码
    pageSize:pageSize,//页大小
    period:period,//周期
    frameid:frameid,//部门id
    kpitype:kpitype,//类型 0月度 1季度
    years:years,//年
  };

  return await PostWithParas('fcf73535-c19f-4360-8c6b-a4e657528eb8',paras,title);
}

//上月/上季度KPi列表
async function PrevKPIitem(periodType,userCode,title){
  var paras={
    periodType:periodType,//周期 0月度 1季度
    userCode:userCode,//操作人工号
  };

  return await PostWithParas('6874c458-34c4-4f09-9677-286eff41e067',paras,title);
}

//复制KPI
async function AddKPIByPrev(ids,userCode){
  //ids:ids,//复制的KPI
  var paras={
    userCode:userCode,//操作人工号
  };

  return await PostWithParas('1b9f0582-c025-4531-af50-70aeada61f77',paras,ids);
}

//获取KPI 结果
async function GetUserByItemId(kpiItemId,p,pageSize,title){
  var paras={
    kpiItemId:kpiItemId,//KPIitemId
    p:p,//页码
    pageSize:pageSize,//页大小
  };
  return await PostWithParas('675c2f21-0ec4-419f-b04d-bfe971232c0a',paras,title);
}

//提交月度/季度KPI
async function AddKPI(periodType,userId,userCode,trueName){
  var paras={
    periodType:periodType,//类型   0月度  1季度
    userId:userId,//当前登录人id
    userCode:userCode,//工号
    trueName:trueName,//真实姓名
  };
  return await PostWithParas('9728547e-04fa-478e-9aac-597675bdb18d',paras,{});
}

//发送消息提醒
async function SendMessage(trueName){
  var paras={
    trueName:trueName,//真实姓名
  };
  return await GetByParas('a231276e-ca9c-47dc-8057-26cb9fad649d',paras);
}

function GetQuarter() {
  var q = 1;
  var m = new Date().getMonth() + 1;
  if (m == 1 || m == 2 || m == 3) {
    q = 1;
  } else if (m == 4 || m == 5 || m == 6) {
    q = 2;
  } else if (m == 7 || m == 8 || m == 9) {
    q = 3;
  } else if (m == 10 || m == 11 || m == 12) {
    q = 4;
  }
  return q;
}
function GetMonth() {
  var m = new Date().getMonth() + 1;
  return m;
}
export {
  GetKPISettingList,
  ViewKPIDetail,
  GetKPINameOptions,
  GetChargeDeptsByUserCode,
  GetMonth,
  GetQuarter,
  GetTempateByKPITypeAndKPIName,
  DeleteKPIItem,
  SaveKPIItems,
  GetMyKPI,
  UpdateSelfScore,
  GetMyKPIScore,
  GetNeedMyScoreKPI,
  UpdateLeadScore,
  AuditkpiList,
  GetTreeDeptsData,
  GetPageUserKPIByDeptId,
  GetItemListByInfoPC,
  UpdateStatus,
  UpdateKPIStatus,
  MyUserKpi,
  SendFrameResult,
  GetKPIScore,
  GetFrameListByPid,
  GetUsers,
  PrevKPIitem,
  AddKPIByPrev,
  GetUserByItemId,
  AddKPI,
  SendMessage
};
